module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0